import { useEffect, useState } from 'react';
import styles from './UpdateUser.module.scss';
import { useNavigate } from 'react-router-dom';
import {
	user_management_service,
} from 'src/constants/url';
import { baseApiCall } from 'src/api/Api';
import '../addUser/AddUserstyle.scss'; // this for multi-select disable colour
import {
	BackButton,
	Button,
	CustomTab,
	ErrorModal,
	SuccessModal,
} from 'src/components';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import globalstyle from 'src/assets/scss/global.module.scss';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import { Regex } from 'src/constants/constant';
import { Title, commonVaribles } from 'src/constants/constVariables';
import CheckBox from 'src/components/Atoms/CheckBox/CheckBox';

export const UpdateUser = () => {
	const navigate = useNavigate();
	const { user } = useAuthorizationContext();
	const { plants } = useSelector((state) => state?.allPlants || {});
	const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
	const [statusCode, setStatusCode] = useState('');
	const [isButtonDisable, setIsButtonDisable] = useState(true);
	const [pincode, setPincode] = useState('');
	const [isModalOpen, setModalIsOpen] = useState(false);
	const [title, setTitle] = useState('');

	const selectedRecord = useSelector(
		(state) => state?.updatedData?.updatedData || {}
	);

	const {
		id,
		plant_id,
		full_name,
		domain_name,
		email_id,
		vendor_code,
		mobile_no,
		user_role_id,
		user_role_name,
		commodity_type_id,
		commodity_type_name,
		buyer_code,
		is_admin_access,
	} = selectedRecord;

	const updatePlant = plants?.find((item) => item?.value === plant_id);
	let new_options = { label: updatePlant?.value, value: updatePlant?.label };
	let user_role_selected_options = { label: user_role_name, value: user_role_id };
	let commodity_type_selected_options = { label: commodity_type_name, value: commodity_type_id };
	
	const [userDetails, setUserDetails] = useState({
		selected_plant: new_options,
		full_name: full_name || '',
		domain_name: domain_name || '',
		email_id: email_id || '',
		vendor_code: vendor_code || '',
		mobile_no: mobile_no || '',
		plants: [],
		user_role: [],
		selected_user_role: user_role_selected_options || {},
		commodity_type: [],
		selected_commodity_type: commodity_type_selected_options || {},
		buyer_code: buyer_code || '',
		is_admin_access: is_admin_access || false,
	});
	const [errorMessage, setErrorMessage] = useState({
		full_name: false,
		domain_name: false,
		email_id: false,
		vendor_code: false,
		duplicate_record: false,
		mobile_no: false,
		buyer_code: false,
	});

	useEffect(() => {
		let new_options;
		new_options = plants.reduce(function (acc, current) {
			acc.push({ label: current?.value, value: current?.label });
			return acc;
		}, []);

		setUserDetails((prev) => ({
			...prev,
			plants: new_options,
		}));
	}, [plants]);

	useEffect(() => {
		fetchUserRoleList();
	}, []);

	useEffect(() => {
		if (userDetails?.selected_plant?.value) {
			fetchCommodityList();
		}
	}, [userDetails?.selected_plant?.value]);

	const customStyle = {
		control: (provided, state) => ({
			...provided,
			minHeight: '2rem',
		}),
		indicatorSeparator: (state) => ({
			display: 'none',
		}),
		singleValue: (provided) => ({
			...provided,
			color: 'none',
		}),
	};

	const handleChangeSelect = (value, name) => {
		switch (name) {
			case 'selected_plant':
				setUserDetails((prev) => ({
					...prev,
				}));
				break;
			default:
				break;
		}
		setUserDetails((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleDataChange = (event) => {
		const { name, value } = event.target;
		event.target.value.trim();
		setUserDetails((prev) => ({
			...prev,
			[name]: value,
		}));
		if (
			(!Regex.full_name.test(value) && name === 'full_name' && value !== '') ||
			(!Regex.domain_name.test(value) && name === 'domain_name' && value !== '') ||
			(!Regex.email_id.test(value) && name === 'email_id' && value !== '') ||
			(!Regex.mobile_no.test(value) && name === 'mobile_no' && value !== '') ||
			(!Regex.buyer_code.test(value) && name === 'buyer_code' && value !== '')
		) {
			setErrorMessage((prev) => ({
				...prev,
				[name]: true,
			}));
		} else {
			setErrorMessage((prev) => ({
				...prev,
				[name]: false,
			}));
		}
	};

	const fetchUserRoleList = () => {
		baseApiCall({
			url: user_management_service.GET_USER_ROLE_DETAILS,
			requestBody: {
				plant_id: userDetails.selected_plant?.label,
				Skipinterceptors: true,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data && res.data.result && res.data.result !== '') {
					const data = res.data.result;
					setUserDetails((prev) => ({
						...prev,
						user_role: data,
					}));
				}
			},
			onFailure: () => {},
			errorCall: () => {},
		});
	};

	const fetchCommodityList = () => {
		baseApiCall({
			url: user_management_service.GET_COMMODITY_TYPE_ROLE_DETAILS,
			requestBody: {
				plant_id: userDetails.selected_plant?.label,
				Skipinterceptors: true,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.result && res?.data?.result !== '') {
					const data = res.data.result;
					setUserDetails((prev) => ({
						...prev,
						commodity_type: data,
					}));
				}
			},
			onFailure: () => {},
			errorCall: () => {},
		});
	};

	const submitForm = () => {
		baseApiCall({
			url: user_management_service.UPDATE_USER,
			requestBody: {
				id,
				full_name: userDetails?.full_name,
				email_id: userDetails?.email_id,
				mobile_no: userDetails?.mobile_no,
				updated_by: user?.name,
				commodity_type_id : userDetails?.selected_commodity_type?.value,
				buyer_code: userDetails?.buyer_code,
				is_admin_access: userDetails?.is_admin_access,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res.data.status === 200) {
					setModalIsOpen(true);
					setTitle(res.data.message);
				}
			},
			onFailure: (res) => {
				setIsErrorModalOpen(true);
				setStatusCode(res.response.data.status);
				setTitle(res.message);
			},
			errorCall: (res) => {
				setIsErrorModalOpen(true);
				setStatusCode(res.response.data.status);
				setTitle(res.response.data.message);
			},
		});
	};
	
	const handleCheckboxChange = (status) => {
		setUserDetails((prev) => ({
			...prev,
			is_admin_access: status,
		}));
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const formValid = () => {
		const {
			full_name,
			domain_name,
			email_id,
			selected_plant,
			selected_user_role,
			vendor_code,
			mobile_no,
			selected_commodity_type,
			buyer_code
		} = userDetails;
		if (selected_user_role?.label != 'Supplier') {
			if (selected_user_role?.label == 'Direct Material Purchase Buyer') {
				return (
					full_name &&
					domain_name &&
					email_id &&
					selected_plant?.label &&
					selected_user_role?.label &&
					mobile_no &&
					selected_commodity_type?.label &&
					buyer_code &&
					!errorMessage.full_name &&
					!errorMessage.selected_user_role &&
					!errorMessage.domain_name &&
					!errorMessage.email_id &&
					!errorMessage.mobile_no &&
					!errorMessage.buyer_code
				);
			}
			return (
				full_name &&
				domain_name &&
				email_id &&
				selected_plant?.label &&
				selected_user_role?.label &&
				mobile_no &&
				!errorMessage.full_name &&
				!errorMessage.selected_user_role &&
				!errorMessage.domain_name &&
				!errorMessage.email_id &&
				!errorMessage.mobile_no
			);
		}
		return (
			full_name &&
			domain_name &&
			email_id &&
			selected_plant?.label &&
			selected_user_role?.label &&
			vendor_code &&
			mobile_no &&
			!errorMessage.full_name &&
			!errorMessage.selected_user_role &&
			!errorMessage.domain_name &&
			!errorMessage.email_id &&
			!errorMessage.mobile_no &&
			!errorMessage.vendor_code
		);
	};

	useEffect(() => {
		setIsButtonDisable(!formValid());
	}, [userDetails, errorMessage, formValid]);


	return (
		<div className={styles['add-user-form']}>
			<div className={globalstyle['breadcrumb']}>
				<BackButton
					basePath={Title.user_management}
					action={Title.update_user}
					handleClick={() => {
						navigate('/user-management');
					}}
					browserBack={true}
				/>
			</div>
			<div>
				<CustomTab
					title={Title.update_user}
					withOutCount
					withOutFilters={true}
				/>
			</div>
			<div className={styles['form-group']}>
				<div className={styles['user-form']}>
					<div className={styles['form-head']}>
						<span>{Title.update_user}</span>
					</div>
					<form className={styles['form-body']}>
						<div className={styles['form-data']}>
							<label className={styles['form-label']}>Plant*</label>
							<div className={styles['user-group']}>
								<Select
									className={styles['input-box']}
									styles={customStyle}
									value={userDetails.selected_plant}
									options={userDetails.plants}
									onChange={(e) => handleChangeSelect(e, 'selected_plant')}
									isDisabled={true}
								/>
							</div>
						</div>
						<div className={styles['form-data']}>
							<label className={styles['form-label']}>Full Name*</label>
							<div className={styles['user-group']}>
								<input
									className={styles['text-box']}
									value={userDetails.full_name}
									type="text"
									name="full_name"
									onChange={handleDataChange}
								/>
								{errorMessage.full_name && (
									<span className={styles['errormsg']}>
										{commonVaribles.errorMsgForName}
									</span>
								)}
							</div>
						</div>
						<div className={styles['form-data']}>
							<label className={styles['form-label']}>Domain Name*</label>
							<div className={styles['user-group']}>
								<input
									className={styles['text-box']}
									value={userDetails.domain_name}
									type="text"
									name="domain_name"
									onChange={handleDataChange}
									disabled={true}
								/>
								{errorMessage.domain_name && (
									<span className={styles['errormsg']}>
										{commonVaribles.errorMsgForsername}
									</span>
								)}
							</div>
						</div>
						<div className={styles['form-data']}>
							<label className={styles['form-label']}>Email ID*</label>
							<div className={styles['user-group']}>
								<input
									className={styles['text-box']}
									value={userDetails.email_id}
									type="text"
									name="email_id"
									onChange={handleDataChange}
									disabled={true}
								/>
								{errorMessage.email_id && (
									<span className={styles['errormsg']}>
										{commonVaribles.errorMsgForEmail}
									</span>
								)}
							</div>
						</div>
						<div className={styles['form-data']}>
							<label className={styles['form-label']}>Mobile No.*</label>
							<div className={styles['user-group']}>
								<input
									className={styles['text-box']}
									value={userDetails.mobile_no}
									type="tel"
									maxLength="10"
									pattern="^\d{10}$"
									name="mobile_no"
									onChange={handleDataChange}
								/>
								{errorMessage.mobile_no && (
									<span className={styles['errormsg']}>
										{commonVaribles.errorMsgForMobileNumber}
									</span>
								)}
							</div>
						</div>
						
						<div className={styles['form-data']}>
							<label className={styles['form-label']}>User Role*</label>
							<div className={styles['user-group']}>
								<Select
									className={styles['input-box']}
									styles={customStyle}
									value={userDetails.selected_user_role}
									onChange={(e) => handleChangeSelect(e, 'selected_user_role')}
									isDisabled={true}
								/>
							</div>
						</div>

						{ userDetails?.selected_user_role?.label == 'Direct Material Purchase Buyer' && (
							<>
								<div className={styles['form-data']}>
									<label className={styles['form-label']}>Commodity Name*</label>
									<div className={styles['user-group']}>
										<Select
											className={styles['input-box']}
											styles={customStyle}
											options={userDetails.commodity_type}
											onChange={(e) => handleChangeSelect(e, 'selected_commodity_type')}
											value={userDetails.selected_commodity_type}
										/>
									</div>
								</div>
								
								<div className={styles['form-data']}>
									<label className={styles['form-label']}>Buyer Code*</label>
									<div className={styles['user-group']}>
										<input
											className={styles['text-box']}
											value={userDetails.buyer_code}
											type="text"
											name="buyer_code"
											onChange={handleDataChange}
										/>
										{errorMessage.buyer_code && (
											<span className={styles['errormsg']}>
												{commonVaribles.errorMsgForBuyerCode}
											</span>
										)}
									</div>
								</div>
							</>
						)}

						{userDetails?.selected_user_role?.label != 'Admin' &&
							userDetails?.selected_user_role?.label != 'Supplier' && (
								<div className={styles['form-data']}>
									<span className={styles['form-label']}>Admin Access?</span>
									<div className={styles['user-group']}>
										<CheckBox
											isChecked={userDetails?.is_admin_access}
											onChange={() =>
												handleCheckboxChange(!userDetails?.is_admin_access)
											}
										/>
									</div>
								</div>
							)
						}

						{userDetails?.selected_user_role?.label == 'Supplier' && (
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Vendor code*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={userDetails.vendor_code}
										type="text"
										name="vendor_code"
										onChange={handleDataChange}
										disabled={true}
									/>
									{errorMessage.vendor_code && (
										<span className={styles['errormsg']}>
											{commonVaribles.errorMsgForVendorCode}
										</span>
									)}
								</div>
							</div>
						)}
					</form>
		</div>
        <div className={styles['button-container']}>
          <div className={globalstyle['border']}></div>
          <div className={styles['button']}>
                <Button
                  className={styles.button}
                  variant="okButton"
                  onClick={() => {
                    submitForm();
                  }}
                  disabled={isButtonDisable}
                >
                  Update
                </Button>
          </div>
        </div>
      </div>
      {
				<SuccessModal
					open={isModalOpen}
					handleClose={() => navigate('/user-management')}
					title={title}
					pincode={pincode}
				/>
			}
			{
				<ErrorModal
					open={isErrorModalOpen}
					title={title}
					handleClose={() => setIsErrorModalOpen(false)}
					code={statusCode}
				/>
			}
		</div>
	);
};
